import { useContext } from "react";
import { TabsContext } from "../providers";

export function useTabs() {
  return useContext(TabsContext);
}
